/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_SuccessInputs */



/**
* | output |
* | --- |
* | "Your subscription will be cancelled at the end of the current billing period." |
*
* @param {Cancel_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cancel_success = /** @type {((inputs?: Cancel_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre abonnement sera annulé à la fin de la période de facturation en cours.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihr Abonnement wird zum Ende des aktuellen Abrechnungszeitraums gekündigt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'abbonamento verrà annullato al termine del periodo di fatturazione corrente.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ваша подписка будет аннулирована по окончании текущего расчетного периода.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Su suscripción se cancelará al final del período de facturación actual.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您的订阅将在当前计费周期结束时取消。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在の請求期間の終了時にサブスクリプションはキャンセルされます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान बिलिंग अवधि के अंत में आपकी सदस्यता रद्द कर दी जाएगी।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sua assinatura será cancelada ao final do período de faturamento atual.")
	return /** @type {LocalizedString} */ ("Your subscription will be cancelled at the end of the current billing period.")
});